module.exports = __webpack_public_path__ + "static/media/logo_mobile.b76a3a25.svg";